import { Link } from "react-router-dom";
import { FileText, ArrowRight } from "lucide-react";
import { useApi } from "@/lib/api";
import { useSeo } from "@/lib/site";
import { PageIntro } from "@/components/site/PageIntro";
import { ArticleLibrary } from "@/components/site/ArticleLibrary";

const Tools = () => {
  const { data } = useApi("/tools");
  return (
    <section className="container-site mt-20" aria-labelledby="tools-heading" data-testid="direction-tools">
      <div className="rounded-[2.5rem] bg-sage-light p-6 sm:p-10 lg:p-14">
        <p className="eyebrow mb-3">Practical tools</p>
        <h2 id="tools-heading" className="text-3xl sm:text-4xl">Worksheets you can print or fill in.</h2>
        <p className="mt-4 text-ink-soft max-w-2xl">Each worksheet opens as a printable page. Use your browser's print option to print it or save it as a PDF. Nothing you write is sent to us.</p>
        <div className="mt-8 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {(data || []).map((t) => (
            <Link key={t.slug} to={`/resources/${t.slug}`} className="group card-soft !bg-white p-6 flex flex-col gap-3 hover:-translate-y-0.5 transition-transform" data-testid={`tool-card-${t.slug}`}>
              <FileText className="h-6 w-6 text-sage-dark" aria-hidden="true" />
              <h3 className="text-xl font-semibold">{t.title}</h3>
              <p className="text-ink-soft text-[0.97rem]">{t.description}</p>
              <span className="mt-auto inline-flex items-center gap-1 text-sm font-semibold text-teal">Open worksheet <ArrowRight className="h-4 w-4" aria-hidden="true" /></span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default function DirectionHub() {
  useSeo("Direction", "Practical guidance for families and friends navigating someone else's addiction.");
  return (
    <>
      <PageIntro eyebrow="Direction" title="Finding your way through difficult moments." testId="direction-intro">
        <p>When someone you care about is experiencing addiction, even simple decisions can feel complicated. Explore practical guidance to help you understand your options and decide what comes next.</p>
      </PageIntro>
      <ArticleLibrary hub="direction" />
      <Tools />
    </>
  );
}
